import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  Select,
  Typography,
  Upload,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { LeftOutlined, CloseCircleFilled } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import AreYouSure from "../../../Modal/AreYouSure";
import ExitAreYouSure from "../../../Modal/ExitAreYouSure";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import config from "../../../config";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { helpers } from "../../../utils/helper/helper";
import { useLocation } from 'react-router-dom';

// const allBranch = [
//   {
//     value: "1",
//     label: "Butterscotch Cake",
//   },
//   {
//     value: "2",
//     label: "Custom Product",
//   },
// ];
const SubmitOrderQC = () => {
  const dispatch = useDispatch();
  
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderDetailId = params.get('orderDetailId');
  
  const cropperRef = useRef(null);
  let { id } = useParams();
  const { TextArea } = Input;
  const navigate = useNavigate();
  const [fileList, setFileList] = useState([]);
  const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);
  const [isExitAreYouSureModalOpen, setIsExitAreYouSureModalOpen] =
    useState(false);

  const [form] = Form.useForm();

  const handleAreYouSureOk = async () => {
    setIsAreYouSureModalOpen(false);
  };
  const handleAreYouSureCancel = () => {
    setIsAreYouSureModalOpen(false);
  };
  const handleExitAreYouSureOk = async () => {
    setIsExitAreYouSureModalOpen(false);
  };
  const handleExitAreYouSureCancel = () => {
    setIsExitAreYouSureModalOpen(false);
  };
  // const handleRemove = (file) => {
  //   setFileList([]);
  // };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <img src={config.IMAGEBASEURL + `images/upload-img.png`} alt="Upload" />
    </button>
  );

  const [orderDetailData, setOrderDetailData] = useState({});
  const [qcRequestData, setQcRequestData] = useState({});
  const [productsList, setProductsList] = useState([]);
  
  const getOrdersDetail = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {};
      let response = await globalRequest(
        Apis.ORDERS.GET_ORDER_DETAIL + "/" + id,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data?.data;
      if (response?.status === 200) {
        setOrderDetailData(apiResponse.data);
        setQcRequestData(apiResponse.qc_request);
        let list = apiResponse?.data?.orderDetails
          ?.map((detail, index) => {
            // Find the product locale with the language code 'en'
            let token = true;
        
            if (apiResponse?.qc_request?.length) {
              for (let qc_request of apiResponse?.qc_request) {
                if (detail?.id === qc_request?.orderDetailId && (qc_request?.status === 'approve' || qc_request?.status ==='in_review')) {
                  token = false;
                  break; // No need to continue the loop if we already found a match
                }
              }
            }
        
            if (token &&  apiResponse.data.vendorId === detail.vendorId && detail.vendorType!=='host') {
              if (detail?.type === 'custom') {
                return {
                  value: detail?.id,
                  label: 'Custom product ' + (index + 1), // Check if locale exists to prevent errors
                };
              } else {
                let locale = detail.orderItemJson?.productLocales?.find(
                  (local) => local.languageCode === 'en'
                );
        
                return {
                  value: detail.id,
                  label: locale ? locale.name : '', // Check if locale exists to prevent errors
                };
              }
            }
        
            return null; // Return null if token is false
          })
          .filter(item => item !== null); 
        setProductsList(list);

        // setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  
  useEffect(() => {
    getOrdersDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [formData, setFormData] = useState({
    order_detail_id: null,
    comment: "",
    images: [],
  });

  useEffect(()=>{
    if(orderDetailId!==null)form.setFieldValue("order_detail_id", +orderDetailId);
  },[orderDetailId])

  const [image, setImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleSubmit = async (values) => {
    
    let insertData = {
      order_id:id,
      order_detail_id: formData.order_detail_id,
      imagesData: formData.images,
      comment: formData.comment,
    };

    if (formData.images.length === 0) {
      toast.error("Image is requried.");
      return false;
    }

    dispatch(changeLoader(true));
    try {
      let url = Apis?.ORDERS?.SUBMIT_TO_QC;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Request created successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/order-management");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleUpload = ({ file }) => {
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > maxSize) {
      // Show an error message or notification
      toast.error("File size must be less than 5 MB.");
      return false; // Prevent adding the file to the file list
    }

    if (file.status === "removed") return false;
    // setImageData({ imagename: file.name, imagetype: file.type });
    const reader = new FileReader();
    reader.onload = () => setImage(reader.result);
    reader.readAsDataURL(file);
    setPreviewOpen(true);
    return false; // Prevent automatic upload
  };

  // const handleCrop = () => {
  //   const cropper = cropperRef.current?.cropper;
  //   if (cropper) {
  //     const croppedImage = cropper.getCroppedCanvas().toDataURL();
  //     setPreviewOpen(false);
  //     uploadImage(croppedImage);      
  //   }
  // };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 500, // Reduce width (Adjust as needed)
        height: 500, // Reduce height
      });

      const croppedImage = canvas.toDataURL("image/jpeg", 0.7); // Lower quality to 70%
      setPreviewOpen(false);
      uploadImage(croppedImage);
    }
  };

  const uploadImage = async (file) => {
    let insertData = {
      files: file,
      title_en: "",
    };

    dispatch(changeLoader(true));
    
    try {
      let url = Apis?.ORDERS?.ADD_IMAGES_FOR_QC;
      let method = "post";
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let name = apiResponse?.data[0].name;
        let path = apiResponse?.data[0].path;

        setFormData((prev) => ({
          ...prev,
          images: [...prev?.images, { image: path }],
        }));

        // let prevFormData = helpers.deepCopy(formData);

        // prevFormData.images.push({
        //   image: path,
        // });

        // prevFormData.variant[imageVariantIndex].imageErr = "";

        // setFormData(prevFormData);

        // let errors = helpers.deepCopy(formData);
        // errors.variant[imageVariantIndex].imageErr = "";
        // setFormData(errors);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const handleRemove = (file) => {
    setFileList([]);
    // setPreviewImage("");
    setPreviewOpen(false);
  };

  const removeImage = (name, imageIndex) => {
    let prevFormData = helpers.deepCopy(formData);
    // Remove image at imageIndex from the images array of the specific variant
    prevFormData.images.splice(imageIndex, 1);
    setFormData(prevFormData);
  };

  return (
    <>
      <Card>
        <div className="mb-4">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            Submit order for QC
          </Typography>
          <p className="w-full max-w-[900px]">
            Send the prepared product for a quality check to verify compliance
            with our standards. Ensure it meets all quality requirements before
            proceeding.
          </p>
        </div>
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            form={form}
            onFinish={(e) => {
              handleSubmit(e);
              // manageNonFormValidations();
            }}
            layout="vertical"
            className="flex flex-col gap-5"
          >
            <Card>
              <div className="my-4">
                <Form.Item
                  label="Product"
                  name="order_detail_id"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    placeholder="Select"
                    options={productsList}
                    showSearch
              filterOption={(input, productsList) =>
                (productsList?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
                    value={formData?.order_detail_id}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        order_detail_id: e,
                      }));
                    }}
                  />
                </Form.Item>
              </div>
              <div className="relative">
                <h6 className="font-semibold">Upload Images</h6>
                <p className="text-[#808080] w-full max-w-[750px]">
                  Supports JPEG, PNG, JPG only, Max file size 5 MB & Max 5
                  images for each prepared item
                </p>
              </div>
              <div className="flex gap-5 my-4 h-[102px]">
                {
                  formData.images.length < 5 ? (
                    <Upload
                      listType="picture-card"
                      fileList={fileList}
                      beforeUpload={() => false}
                      onChange={(e) => {
                        handleUpload(e);
                        // setImageVariantIndex(variantIndex);
                      }}
                      onRemove={handleRemove}
                      showUploadList={{
                        showPreviewIcon: true,
                      }}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                  ) : null
                }
                {
                  formData.images?.map(
                    (image, imageIndex) => {
                      return (
                        <div
                          className="relative"
                          key={imageIndex}
                        >
                          <img
                            src={
                              config.AWS_URL + image?.image
                            }
                            alt={image?.name}
                            className="w-[100px] h-[100px] "
                          />
                          <div className="absolute top-0 p-2 right-0">
                            <CloseCircleFilled
                              className="text-[#BA1A1A] text-[18px] cursor-pointer"
                              onClick={() =>
                                removeImage(
                                  image.name,
                                  imageIndex
                                )
                              }
                            />
                          </div>
                        </div>
                      );
                    }
                  )
                }
                
                {/* <div className="relative">
                  <img
                    src="images/cake2.png"
                    alt="cake2"
                    className="w-[100px] h-[100px] "
                  />
                  <div className="absolute top-0 p-2 right-0">
                    <CloseCircleFilled className="text-[#BA1A1A] text-[18px] cursor-pointer" />
                  </div>
                </div>
                <div className="relative">
                  <img
                    src="images/cake2.png"
                    alt="cake2"
                    className="w-[100px] h-[100px] "
                  />
                  <div className="absolute top-0 p-2 right-0">
                    <CloseCircleFilled className="text-[#BA1A1A] text-[18px] cursor-pointer" />
                  </div>
                </div>
                <div className="relative">
                  <img
                    src="images/cake2.png"
                    alt="cake2"
                    className="w-[100px] h-[100px] "
                  />
                  <div className="absolute top-0 p-2 right-0">
                    <CloseCircleFilled className="text-[#BA1A1A] text-[18px] cursor-pointer" />
                  </div>
                </div> */}
              </div>
            </Card>
            <Card>
              <div className="my-4">
                <Typography
                  className="text-base font-semibold mb-2"
                  align={"left"}
                >
                  Comments
                </Typography>
                <Form.Item
                  name="comment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <TextArea
                    showCount
                    value={formData?.comment}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        comment: e.target?.value?.trimStart(),
                      }));
                    }}
                    maxLength={300}
                    size="large"
                  />
                </Form.Item>
              </div>
            </Card>
          </Form>
          <div className="flex justify-end gap-3 mt-6">
            <Button
              className="h-[39px]"
              // onClick={() => {
              //   setIsExitAreYouSureModalOpen(true);
              // }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button
              className="h-[39px]"
              type="primary"
              htmlType="submit"
              onClick={() => form.submit()}
              // onClick={() => {
              //   setIsAreYouSureModalOpen(true);
              // }}
            >
              Submit
            </Button>
          </div>
        </div>
      </Card>
      <Modal
        open={previewOpen}
        onCancel={() => setPreviewOpen(false)}
        footer={[
          <Button key="back" onClick={() => setPreviewOpen(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleCrop}>
            Crop and Upload
          </Button>,
        ]}
      >
        <Cropper
          src={image}
          style={{ height: 400, width: "100%" }}
          aspectRatio={1}
          guides={false}
          ref={cropperRef}
        />
      </Modal>
      <AreYouSure
        isOpen={isAreYouSureModalOpen}
        onOk={handleAreYouSureOk}
        onCancel={handleAreYouSureCancel}
      />
      <ExitAreYouSure
        isOpen={isExitAreYouSureModalOpen}
        onOk={handleExitAreYouSureOk}
        onCancel={handleExitAreYouSureCancel}
      />
    </>
  );
};

export default SubmitOrderQC;
